var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "320", persistent: true },
      model: {
        value: _vm.dialogIsOpen,
        callback: function($$v) {
          _vm.dialogIsOpen = $$v
        },
        expression: "dialogIsOpen"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-box home-form-container" },
        [
          _c("h2", { staticClass: "cassette-title" }, [
            _vm._v(
              _vm._s(
                _vm.action === "create"
                  ? "" + _vm.$t("New")
                  : "" + _vm.$t("Edit")
              ) +
                " " +
                _vm._s(_vm.$t("Cassette"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cassette-label-input mb-4" }, [
            _c("label", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.$tc("Label", 1) + " *"))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.object.label,
                  expression: "object.label"
                }
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.object.label },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.object, "label", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.action === "create"
            ? _c(
                "div",
                { staticClass: "cassette-form-item mb-5" },
                [
                  _c("label", { staticClass: "mb-1" }, [
                    _vm._v(_vm._s(_vm.$tc("MaterialReference", 1) + " *"))
                  ]),
                  _vm._v(" "),
                  _c("treeselect", {
                    staticClass: "cassette-form-input-select",
                    attrs: {
                      options: _vm.cassetteOptions,
                      normalizer: _vm.cassetteOptionsNormalizer,
                      disableFuzzyMatching: ""
                    },
                    model: {
                      value: _vm.object.material_id,
                      callback: function($$v) {
                        _vm.$set(_vm.object, "material_id", $$v)
                      },
                      expression: "object.material_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "cassette-form-buttons" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button",
                  attrs: { ripple: false, text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close-cassette-form")
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button",
                  attrs: { disabled: _vm.isDisabled, ripple: false, text: "" },
                  on: { click: _vm.saveObject }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.action === "create"
                          ? _vm.$t("Save")
                          : _vm.$t("Edit")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f29e63e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f29e63e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/forms/AddOrEditCassetteForm.vue
// module id = null
// module chunks = 